module.exports = __webpack_public_path__ + "24c10a185fb385256bc70abb377e9eee.pdf";